import { Injectable, ComponentRef, ComponentFactoryResolver, ViewContainerRef } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { SelfSchedulingConfigModel, SelfSchedulingWrapper } from 'src/app/shared/models/response/settings/self-scheduling-config-model';

@Injectable({
  providedIn: 'root',
})
export class SidebarService {
  private sidebarVisible = new BehaviorSubject<boolean>(false);
  private data$ = new BehaviorSubject<SelfSchedulingWrapper | null>(null);
  private componentRef: ComponentRef<any> | null = null;
  private viewContainerRef!: ViewContainerRef;

  constructor(private resolver: ComponentFactoryResolver) { }

  setViewContainerRef(vcr: ViewContainerRef) {
    this.viewContainerRef = vcr;
  }

  open(component: any, data?: any) {
    if (!this.viewContainerRef) return;

    this.viewContainerRef.clear();
    const factory = this.resolver.resolveComponentFactory(component);
    this.componentRef = this.viewContainerRef.createComponent(factory);

    if (data) {
      Object.assign(this.componentRef.instance, data);
    }

    this.data$.next(data);
    this.sidebarVisible.next(true);
  }

  close() {
    this.sidebarVisible.next(false);
    if (this.componentRef) {
     this.data$.next(null);
      this.componentRef.destroy();
      this.componentRef = null;
    }
  }

  isSidebarVisible() {
    return this.sidebarVisible.asObservable();
  }

  sidebarData() {
    return this.data$.asObservable();
  }
}
